import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'
import OtpInput from 'react-otp-input'
import ActionButton from '../../../ui/ActionButton/ActionButton'
import Spinner from '../../Spinner/Spinner/Spinner'

const ButtonWrapper = styled.div`
  margin: 1rem 0 0;
`
const BlockButton = styled(ActionButton)`
  width: 100%;
`
const OtpContainer = styled.div`
  padding-top: 1rem;
  padding-bottom: 1rem;
`
const StyledInput = styled.input`
  outline: 0;
  font-size: 24px;
  padding-bottom: 8px;
  width: 40px !important;
  background-color: transparent;
  font-weight: var(--font-weight-bold);

  border: none;
  border-bottom: ${props =>
    props.hasError
      ? '1px var(--color-error) solid'
      : props.value !== ''
      ? '2px #000 solid'
      : '1px #ccc solid'};

  // hide up/dpwn spin buttons
  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`
const ResendLabel = styled.div`
  text-align: center;
  padding-top: 3rem;
  font-size: 13px;
`
const ResendError = styled(ResendLabel)`
  color: var(--color-error);
  padding: 0;
  margin-top: 16px;
`
const ResendOptions = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  padding-bottom: 20px;
  justify-content: space-around;
`
const ResendButton = styled.button`
  border: 0;
  font-size: 13px;
  background: transparent;
  color: var(--color-primary);
  text-transform: uppercase;
  font-weight: var(--font-weight-bold);

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`
const otpInputContainerStyles = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
}

const DEFAULT_COUNTDOWN = 300

const OtpForm = props => {
  const {
    handleSubmit,
    // handleChange,
    handleBlur,
    values,
    // errors,
    // touched,
    isSubmitting,
    isValid,
    disabled,
    method,
    setFieldValue,
    action,
    resend,
    removeEmailOTP,
    // ...restProps
  } = props
  const [countdown, setCountdown] = React.useState(DEFAULT_COUNTDOWN)
  const [resendError, setResendError] = React.useState(null)
  const [resendLoading, setResendLoading] = React.useState(false)

  const handleChangeOtp = value => {
    setFieldValue('code', value)
  }
  const handleResend = ({ toMobile }) => {
    resend({
      toMobile,
      setError: setResendError,
      setLoading: setResendLoading,
    })
    setCountdown(DEFAULT_COUNTDOWN)
  }
  const handleResendSMS = e => {
    e.preventDefault()
    handleResend({ toMobile: true })
  }
  const handleResendEmail = e => {
    e.preventDefault()
    handleResend({ toMobile: false })
  }
  const tick = () => {
    if (countdown === 0) {
      return
    }

    setCountdown(countdown - 1)
  }

  React.useEffect(() => {
    const timerID = setInterval(() => tick(), 1000)

    return () => {
      clearInterval(timerID)
    }
  })

  return (
    <form onSubmit={handleSubmit} method={method} action={action}>
      <fieldset disabled={isSubmitting || disabled}>
        <OtpContainer>
          <OtpInput
            id="code"
            numInputs={6}
            shouldAutoFocus
            inputType="number"
            onBlur={handleBlur}
            value={values.code}
            onChange={handleChangeOtp}
            renderSeparator={<span />}
            containerStyle={otpInputContainerStyles}
            renderInput={props => <StyledInput {...props} />}
          />
        </OtpContainer>
        <ResendLabel>
          Didn’t receive your confirmation code?&nbsp;
          {countdown > 0 && `Resend in ${countdown} sec`}
        </ResendLabel>
        <ResendOptions>
          <ResendButton
            disabled={countdown > 0 || resendLoading}
            onClick={handleResendSMS}
          >
            Receive via SMS
          </ResendButton>
          {!removeEmailOTP ? (
            <ResendButton
              disabled={countdown > 0 || resendLoading}
              onClick={handleResendEmail}
            >
              Receive via Email
            </ResendButton>
          ) : null}
        </ResendOptions>
        <ResendError>{resendError || ''}</ResendError>
        <ButtonWrapper>
          <BlockButton type="submit" variant="primary" disabled={!isValid}>
            {!isSubmitting ? 'Verify' : <Spinner color="#fff" width="3px" />}
          </BlockButton>
        </ButtonWrapper>
      </fieldset>
    </form>
  )
}

OtpForm.defaultProps = {
  handleSubmit: null,
  handleChange: null,
  handleBlur: null,
  values: {},
  errors: {},
  touched: {},
  isSubmitting: false,
  isValid: false,
  disabled: false,
  method: 'get',
  action: '',
}

OtpForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  values: PropTypes.shape(),
  errors: PropTypes.shape(),
  touched: PropTypes.shape(),
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  disabled: PropTypes.bool,
  method: PropTypes.oneOf(['get', 'post']),
  action: PropTypes.string,
}

export default OtpForm
